import { render } from "./ProductionEdit.vue?vue&type=template&id=da95b250&scoped=true"
import script from "./ProductionEdit.vue?vue&type=script&lang=js"
export * from "./ProductionEdit.vue?vue&type=script&lang=js"

import "./ProductionEdit.vue?vue&type=style&index=0&id=da95b250&lang=scss&scoped=true"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da95b250"]])

export default __exports__